import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';

import { Form, Input, Button, InputNumber,Checkbox } from 'antd';

import {sagaCreateApp} from '../actions';

class AppCreate extends Component {
  constructor(props){
    super(props);
    this.state = {
      app: {
        name: '',
        packageName: '',
        nextRuleUpdateIntervalFormatted: '',
        description: '',
        distanceFilterMeters: 15,
        locationPingIntervalMS: 60000,
        relevance: 6000,
        discoveryMode: 0,
        shouldCollectData: true,
      },
      errors: {
        nextRuleUpdateIntervalFormatted: null,
      }
    }
  }

  handleCheckboxChange(e){
    let tmpNewApp = {...this.state.app};
    tmpNewApp[e.target.id] = e.target.checked;
    this.setState({
        app: tmpNewApp,
    });
  }

  handleInputChange(e){
    let tmpNewApp = {...this.state.app};
    tmpNewApp[e.target.id] = e.target.value;
    this.setState({
        app: tmpNewApp,
    });
  }

  handleInputNumberChange(id, value){
    let tmpNewApp = {...this.state.app};
    tmpNewApp[id] = value;
    this.setState({
        app: tmpNewApp,
    });
  }

  handleNextRuleUpdateIntervalFormattedChange(e){
    var error = null;
    if (e.target.value.length > 0){
      var regexInterval = /^\d{1,2}:\d{1,2}/g;
      if (!regexInterval.test(e.target.value)){
        error = 'Next rule updated interval should follow the format H(H):M(M)';
      }
    }
    this.setState({
      errors: {
        nextRuleUpdateIntervalFormatted: error,
      }
    });
    this.handleInputChange(e);
  }

  onSaveApp(){
    this.props.addApp(this.state.app);
  }

  errorCheck(){
    return this.state.app.name.length > 0 
            && this.state.app.packageName.length > 0
            && this.state.errors.nextRuleUpdateIntervalFormatted === null
            && this.state.app.description.length > 0
  }

  render() {
      return (
        <div className="container-with-padding">
          <Form>
            <h4 className="heading-level-1" style={{
                marginBottom: 16,
            }}>Create New App</h4>
            <Form.Item label="Name" style={{ marginBottom: 5}}>
                <Input placeholder="Example App"
                    onChange={this.handleInputChange.bind(this)}
                    value={this.state.app.name} id="name" />
            </Form.Item>
            <Form.Item label="App Package Name" style={{ marginBottom: 5}}>
                <Input placeholder="com.LandmarksID.Example"
                    onChange={this.handleInputChange.bind(this)}
                    value={this.state.app.packageName} id="packageName" />
            </Form.Item>
            <Form.Item label="Next Rule Update Interval Formatted"  
                        style={{ marginBottom: 5}}
                        validateStatus={this.state.errors.nextRuleUpdateIntervalFormatted ? "error" : "validating"}
                        help={this.state.errors.nextRuleUpdateIntervalFormatted} >
                <Input placeholder="47:59"
                    onChange={this.handleNextRuleUpdateIntervalFormattedChange.bind(this)}
                    value={this.state.app.nextRuleUpdateIntervalFormatted} id="nextRuleUpdateIntervalFormatted" />
            </Form.Item>
            <Form.Item label="Distance Filter(Meters)" style={{ marginBottom: 5}}>
                <InputNumber placeholder="25"
                    onChange={(value) => {
                      this.handleInputNumberChange('distanceFilterMeters',value);
                    }}
                    value={this.state.app.distanceFilterMeters} id="distanceFilterMeters" />
            </Form.Item>
            <Form.Item label="Location Ping Interval(Milliseconds)" style={{ marginBottom: 5}}>
                <InputNumber placeholder="60000"
                    onChange={(value) => {
                      this.handleInputNumberChange('locationPingIntervalMS',value);
                    }}
                    value={this.state.app.locationPingIntervalMS} id="locationPingIntervalMS" />
            </Form.Item>
            <Form.Item label="Relevance(Milliseconds)" style={{ marginBottom: 5}}>
                <InputNumber placeholder="60000"
                    onChange={(value) => {
                      this.handleInputNumberChange('relevance',value);
                    }}
                    value={this.state.app.relevance} id="relevance" />
            </Form.Item>
            <Form.Item label="Discovery Mode" style={{ marginBottom: 5}}>
                <InputNumber placeholder="60000"
                    onChange={(value) => {
                      this.handleInputNumberChange('discoveryMode',value);
                    }}
                    min={0} max={3}
                    value={this.state.app.discoveryMode} id="discoveryMode" />
            </Form.Item>
            <Form.Item label="" style={{ marginBottom: 10, marginTop: 5 }}>
                <Checkbox value={this.state.app.shouldCollectData} 
                    onChange={this.handleCheckboxChange.bind(this)}
                    id="shouldCollectData">Should Collect Data</Checkbox>
            </Form.Item>
            <Form.Item label="Description" style={{ marginBottom: 5}}>
                <Input.TextArea placeholder="" rows={4}
                    onChange={this.handleInputChange.bind(this)}
                    value={this.state.app.description} id="description" />
            </Form.Item>
            <Form.Item style={{ marginBottom: 5}}>
              <Button type="primary" icon="save" 
                      disabled={!this.errorCheck()}
                      onClick={this.onSaveApp.bind(this)}>Save App</Button>
            </Form.Item>
          </Form>
        </div>
      );
    }
}

AppCreate.propTypes = {
  addApp: PropTypes.func,
}

// Map props to the store

const mapStateToProps = () => ({
  
});

const mapDispatchToProps = (dispatch) => ({
  addApp: (app)=>{
    dispatch(sagaCreateApp(app));
  }
});

export const AppCreateContainer = connect(mapStateToProps,mapDispatchToProps)(AppCreate);


// WEBPACK FOOTER //
// ./src/apps/components/AppCreate.js